import { useState } from "react";
import { useTranslation } from "next-i18next";

const TEXT_CLAMP_THRESHOLD = 300;

export default function SeoPageContent({ seoPage }) {
  const { t } = useTranslation();
  const section = seoPage?.info_section ?? seoPage?.content_section;
  const [isExpanded, setIsExpanded] = useState(false);

  if (!section) return null;

  const title = section.title;
  const text = section.description ?? section.text;

  if (!title && !text) return null;

  const isLong = (text?.length ?? 0) > TEXT_CLAMP_THRESHOLD;

  return (
    <section className="bg-[#F8FAFF] pt-[40px] pb-[80px] md:py-[80px]">
      <div className="max-w-[90%] mx-auto">
        {title && (
          <h2 className="text-center text-[#0A0A0A] text-[36px] font-[700] leading-[120%]">{title}</h2>
        )}

        {text && (
          <div className="mt-[24px] md:mt-[28px]">
            <p
              className={`text-[#0A0A0A] text-[18px] font-[400] leading-[160%] transition-all duration-300 ${
                isLong && !isExpanded ? "line-clamp-4" : ""
              }`}
            >
              {text}
            </p>

            {isLong && (
              <button
                type="button"
                onClick={() => setIsExpanded((prev) => !prev)}
                className="mt-[12px] text-main-pink text-[18px] font-[700] hover:opacity-70 transition-opacity duration-200"
              >
                {isExpanded ? t("seo-page.show-less") : t("seo-page.show-more")}
              </button>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
